import { WSEmptyStateProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSEmptyState/WSEmptyState";
import {
  SignatureRequest,
  SignatureRequestStatus
} from "@wingspanhq/wingspan-api-sdk";

import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";
import { RequirementTableItemData } from "../../../../types";

export const payerSignatureRenderCardDescription = (
  requirement: RequirementTableItemData,
  signatureRequest?: SignatureRequest
) => {
  const signatureRequestDescriptions: Record<
    SignatureRequestStatus,
    WSEmptyStateProps
  > = {
    [SignatureRequestStatus.NEW]: {
      type: "documents",
      title: "Document awaiting signature",
      description:
        "Please review and sign the document at your earliest convenience."
    },
    [SignatureRequestStatus.AWAITING_SIGNATURE]: {
      type: "documents",
      title: "Document awaiting signature",
      description:
        "Please review and sign the document at your earliest convenience."
    },
    [SignatureRequestStatus.AWAITING_COUNTERSIGNATURE]: {
      type: "documents",
      title: "Document pending countersignature",
      description:
        "The document has been signed by you and is awaiting countersignature from the client."
    },
    [SignatureRequestStatus.COMPLETED]: {
      type: "done",
      title: "Your e-signature document is complete",
      description: "The fully executed document is available for download."
    }
  };

  return mapStatusesToCardDetails({
    requirement,
    documentStatus:
      signatureRequest?.status ?? SignatureRequestStatus.AWAITING_SIGNATURE,
    documentStatuses: signatureRequestDescriptions,
    pendingApprovalStatus: {
      type: "documents",
      title: "Document pending approval",
      description:
        "All signatures have been collected. The requirement now requires client approval."
    },
    approvedStatus: null,
    rejectedStatus: {
      type: "documents",
      title: "Document was rejected",
      description:
        "The requirement was rejected and may affect your eligibility for related engagements."
    }
  });
};
